import React, { useState } from 'react';
import { Modal, Form, Input, DatePicker, Select, InputNumber } from 'antd';
import { updateEvent, getAllEvents } from '../../../redux/Event/actions';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

const { Option } = Select;
const { TextArea } = Input;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

function EditEventButton({ item }) {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const users = useSelector(state => state.Users?.data || []);
  const companies = useSelector(state => state.companies?.companies || []);
  const countries = useSelector(state => state.countries?.countries || []);

  const showModal = () => {
    onFill();
    setVisible(true);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const hideModal_Cancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFill = () => {
    form.setFieldsValue({
      eventname: item.eventname || '',
      activity: item.activity || '',
      user: item.user ? item.user._id : null, // Assuming user is an object with _id
      company: item.company ? item.company._id : null,
      country: item.country ? item.country._id : null,
      startDate: item.dateAndTime.startDateTime ? moment(item.dateAndTime.startDateTime) : null,
      endDate: item.dateAndTime.endDateTime ? moment(item.dateAndTime.endDateTime) : null,
      location: item.location || '',
      description: item.description || '',
      emailTemplate: item.emailTemplate || '',
      participants: item.participants || 0,
      status: item.status || 'scheduled',
      amount: item.cost?.amount || 0,
      currency: item.cost?.currency || '',
      tags: item.tags ? item.tags.join(', ') : '',
    });
  };

  const form_onFinish = async (values) => {
    const updatedValues = {
      eventname: values.eventname,
      activity: values.activity,
      user: values.user, // Assuming user is a user ID
      company: values.company, // Assuming company is a company ID
      country: values.country, // Assuming country is a country ID
      location: values.location,
      description: values.description,
      emailTemplate: values.emailTemplate,
      participants: values.participants,
      status: values.status,
      cost: {
        amount: values.amount,
        currency: values.currency,
      },
      tags: values.tags ? values.tags.split(',').map(tag => tag.trim()) : [],
      dateAndTime: {
        startDateTime: values.startDate.toISOString(),
        endDateTime: values.endDate.toISOString(),
        timeZone: 'UTC',
      },
    };

    await dispatch(updateEvent(item._id, updatedValues));
    dispatch(getAllEvents());
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <a onClick={showModal}>Modifier</a>
      <Modal
        title="Edit event"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Valider"
        cancelText="Fermer"
      >
        <Form
          {...layout}
          name="basic"
          form={form}
          onFinish={form_onFinish}
        >
          <Form.Item
            label="Name"
            name="eventname"
            rules={[{ required: true, message: 'Please input your event name!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Activity"
            name="activity"
            rules={[{ required: true, message: 'Please input your activity!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Organizer"
            name="user"
            rules={[{ required: true, message: 'Please select an organizer!' }]}
          >
            <Select>
              {users.map((user) => (
                <Option key={user._id} value={user._id}>{user.username}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Company"
            name="company"
          >
            <Select placeholder="Select a company">
              {companies.map((company) => (
                <Option key={company._id} value={company._id}>{company.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Country"
            name="country"
            rules={[{ required: true, message: 'Please select a country!' }]}
          >
            <Select placeholder="Select a country">
              {countries.map((country) => (
                <Option key={country._id} value={country._id}>{country.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: 'Please select a start date!' }]}
          >
            <DatePicker showTime />
          </Form.Item>

          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: true, message: 'Please select an end date!' }]}
          >
            <DatePicker showTime />
          </Form.Item>

          <Form.Item
            label="Location"
            name="location"
            rules={[{ required: true, message: 'Please input the location!' }]}
          >
            <TextArea />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: 'Please input the description!' }]}
          >
            <TextArea />
          </Form.Item>

          <Form.Item
            label="Email Template"
            name="emailTemplate"
          >
            <TextArea />
          </Form.Item>

          <Form.Item
            label="Participants"
            name="participants"
          >
            <InputNumber min={0} />
          </Form.Item>

          <Form.Item
            label="Status"
            name="status"
            rules={[{ required: true, message: 'Please select the status!' }]}
          >
            <Select>
              <Option value="scheduled">Scheduled</Option>
              <Option value="canceled">Canceled</Option>
              <Option value="completed">Completed</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Cost Amount"
            name="amount"
          >
            <InputNumber min={0} />
          </Form.Item>

          <Form.Item
            label="Currency"
            name="currency"
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Tags"
            name="tags"
          >
            <Input placeholder="Enter tags separated by commas" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default EditEventButton;
